import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {GroupResponse, SJC} from "../types/groups/types";
import {BASE_URL} from "../../app.environment";
import {Observable} from "rxjs";
import {
    UpdateImageCaption,
    UpdateImageCustomSJC,
    UpdateImageGroup,
    UpdateImageSafetyAndCostCaptions
} from "../types/groups/params";
import {Make} from "../types/makes/types";

@Injectable({
    providedIn: 'root'
})
export class GroupsService {
    http = inject(HttpClient)
    baseApiUrl = BASE_URL;

    constructor() {

    }

    getImages(params: Record<string, any>, endpoint: string): Observable<GroupResponse> {
        return this.http.get<GroupResponse>(`${this.baseApiUrl}/${endpoint}`, {params: params})
        // return GROUP_RESPONSE_MOCK
    }

    getGroups() {
        return this.http.get<Make[]>(`${this.baseApiUrl}/all_groups`)
        // return GROUPS_MOCK
    }

    getSjcs() {
        return this.http.get<SJC[]>(`${this.baseApiUrl}/sjc`)
    }

    updateImageGroup(body: UpdateImageGroup) {
        return this.http.post(`${this.baseApiUrl}/update/group`, body)
    }

    updateImageCaption(body: UpdateImageCaption) {
        return this.http.post(`${this.baseApiUrl}/update/caption`, body)
    }

    updateImageSafetyAndCostCaption(body: UpdateImageSafetyAndCostCaptions) {
        return this.http.post(`${this.baseApiUrl}/update/safety_and_cost_caption`, body)
    }

    updateSjc(body: UpdateImageCustomSJC) {
        return this.http.post(`${this.baseApiUrl}/update/sjc`, body)
    }

    updateModifiedImage(formData: FormData) {
        return this.http.post(`${this.baseApiUrl}/update/image`, formData)
    }

    exportCSV() {
        return this.http.get(`${this.baseApiUrl}/export`, { responseType: 'blob' })
    }


}
